// extracted by mini-css-extract-plugin
var _1 = "q3bWd";
var _2 = "fzF0q";
var _3 = "TSg5B";
var _4 = "QsGzk";
export { _1 as "panelContent", _2 as "panelFooter", _3 as "panelHeader", _4 as "panelWrapper" }
